var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3C10.7761 3 11 3.22386 11 3.5C11 3.74171 10.8286 3.94371 10.6006 3.99023L10.3994 4.00977C10.1714 4.05629 10 4.25829 10 4.5V11C10 12.1046 9.10457 13 8 13C6.89543 13 6 12.1046 6 11V4.5C6 4.25829 5.82855 4.05629 5.60059 4.00977L5.39941 3.99023C5.17145 3.94371 5 3.74171 5 3.5C5 3.22386 5.22386 3 5.5 3H10.5ZM6.91309 4C6.96847 4.15653 7 4.3245 7 4.5V8.23438L9 7.73438V4.5C9 4.3245 9.03153 4.15653 9.08691 4H6.91309Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalTest);
export default __webpack_public_path__ + "static/media/Medical_test.d4ee5a828dd31d8787795bdbdaff4f40.svg";
export { ForwardRef as ReactComponent };